import React from 'react';
import PropTypes from 'prop-types';

import { useLocation, useNavigate } from "react-router-dom";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import DashboardIcon from '@mui/icons-material/Dashboard';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import InfoIcon from '@mui/icons-material/Info';



const NavBarTabs = ({ isConnected }) => {
    const location = useLocation();
    const navigate = useNavigate();

    if (!isConnected) {
        return null;
    }

    let tabSelected = location.pathname;

    if (tabSelected === '/404' || tabSelected === '/login')
        return null;


    if (tabSelected.startsWith('/reclamations')) {
        tabSelected = '/reclamations';
    }

    if (tabSelected.startsWith('/informations')) {
        tabSelected = '/informations';
    }

    if (!(tabSelected === "/" || tabSelected === "/reclamations" || tabSelected === "/informations")) {
        tabSelected = false;
    }

    return (
        <Tabs value={tabSelected} indicatorColor="secondary" style={{ marginLeft: '50px' }}>
            <Tab value="/" icon={<DashboardIcon />} label="Tableau de bord" onClick={() => navigate("/")} />
            <Tab value="/reclamations" icon={<RecordVoiceOverIcon />} label="Dossiers Après-Vente" onClick={() => navigate("/reclamations")} />
            <Tab value="/informations" icon={<InfoIcon />} label="Informations" onClick={() => navigate("/informations")} />
        </Tabs>
    );
}

NavBarTabs.propTypes = {

    isConnected: PropTypes.bool.isRequired
};

export default NavBarTabs;
